<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否验证允出期："
              prop="validatorDueOutDay"
            >
              <el-radio-group
                v-model="formData.validatorDueOutDay"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="自动下发："
              prop="autoWaveAllocate"
            >
              <el-radio-group
                v-model="formData.autoWaveAllocate"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否分配集货位："
              prop="useGatherGoodsPlace"
            >
              <el-radio-group
                v-model="formData.useGatherGoodsPlace"
                :disabled="isDetail"
                @change="chooseGoodsPlace"
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="允出期外货品下发推送："
              prop="ignoreAppointBatchNoWarning"
            >
              <el-radio-group
                v-model="formData.ignoreAppointBatchNoWarning"
                :disabled="isDetail"
                @change="chooseGoodsPlace"
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="formData.useGatherGoodsPlace" :span="12">
            <el-form-item
              label="同一集货位分配间隔时间(h)："
              prop="intervalTimeGatherGoodsPlace"
            >
              <el-input-number
                v-model="formData.intervalTimeGatherGoodsPlace"
                step-strictly
                :step="1"
                :min="1"
                :max="9999"
                :precision="0"
                :controls="false"
                placeholder="请输入正整数"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="4"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { WAVE_GROUP_OPTIONS, useTransportationInventory, NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      WAVE_GROUP_OPTIONS,
      useTransportationInventory,
      rules: {
        validatorDueOutDay: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        autoWaveAllocate: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        useGatherGoodsPlace: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        intervalTimeGatherGoodsPlace: [
          { required: true, message: '请输入时间间隔', trigger: 'blur' },
        ],
        ignoreAppointBatchNoWarning: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    chooseGoodsPlace() {
      this.$emit('clearGoodsPlace');
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(4);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[4].label}”节点数据`);
        }
      });
    },
  },
};
</script>
